import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { requestNotificationPermission } from 'App/utils/osLevelNotification';
import styled from '@emotion/styled';

const NotificationPermissionHeader = styled('div')`
    display: flex;
    position: relative;
    background: var(--alertWarning);
    width: 100%;

    .notification-prompt {
        margin: auto;
        padding: 0.625rem;
        display: flex;
        align-items: center;
        gap: 5px;
    }
`;

function EnableBrowserNotifications() {
    const [dismissed, setDismissed] = useState(false);

    // Don't show if already granted, denied, or user dismissed
    if (
        dismissed ||
        !('Notification' in window) ||
        Notification.permission === 'granted' ||
        Notification.permission === 'denied'
    ) {
        return null;
    }

    const handleEnable = () => {
        requestNotificationPermission();
        setDismissed(true);
    };

    return (
        <NotificationPermissionHeader id="notification_permission">
            <div className="notification-prompt">
                <span>Enable desktop notifications for session alerts?</span>
                <Button type="button" size="sm" variant="outline-secondary" onClick={handleEnable}>
                    Enable
                </Button>
                <Button type="button" aria-label="Dismiss" size="sm" variant="link" onClick={() => setDismissed(true)}>
                    ✕
                </Button>
            </div>
        </NotificationPermissionHeader>
    );
}

export default EnableBrowserNotifications;
